<template>
    <div class="TextareaView u-InputMarginView" :class="[modes.map((m) => `TextareaView--${m}`),
    { 'TextareaView--error': isError && required }]">
        <span class="TextareaViewRequired" v-if="required">*</span>
        <label class="TextareaViewLabel" :for="`TextareaView-input-${_uid}`" v-if="title">
            {{ title }}
        </label>
        <textarea-autosize class="TextareaViewInput transparent" v-model="formattedValue" :id="`TextareaView-input-${_uid}`"
            :style="{ height: height, width: width }" :placeholder="placeholder" :disallowNewline="disallowNewline" />
    </div>
</template>

<script>
import TextareaAutosize from './TextareaAutosize.vue';

export default {
    name: 'TextareaView',
    mixins: [mixins.ValidationComponentMixin],
    components: {
        TextareaAutosize
    },
    props: {
        title: { type: String, default: '' },
        required: { type: Boolean, default: false },
        value: { type: [Object, String], default: '' },
        height: { type: String, default: '' },
        width: { type: String, default: '100%' },
        placeholder: { type: String, default: 'Текст' },
        disallowNewline: Boolean,
        modes: { type: Array, default: () => [] },
        isError: { type: Boolean, default: false }
    },
    computed: {
        formattedValue: {
            get() {
                return this.value.replace(/<br>/g, '\n');
            },
            set(newValue) {
                this.$emit('input', newValue.target.value.replace(/\n/g, '<br>'));
            }
        }
    },
};
</script>

<style lang="less">
@import "~styles/const.less";

@r: .TextareaView;

@{r} {
    position: relative;
    margin-top: 25px;
    width: 100%;

    &Required {
        color: #A6A6A6;
        position: absolute;
        top: 20px;
        left: -23px;
    }

    &Label {
        color: black;
        font-size: 12px;
        line-height: 16px;
    }

    &Input {
        display: block;
        width: 100%;
        outline: none;
        border: 1px solid #B3B3B3;
        padding: 12px 15px;
        font-weight: @regular;
        color: @color-black;
        background-color: transparent;
        font-size: 12px;
        line-height: 16px;
        margin-top: 10px;
        font-family: @Graphik-LCG;

        &::placeholder {
            color: #B3B3B3;
        }
    }

    &--error {
        .TextareaViewRequired {
            color: @color-red;
        }

        .TextareaViewInput {
            border-bottom-color: @color-red;
        }
    }
}
</style>
